<div class="content-width">
    <form [formGroup]="form">
        <ion-list>
          <ion-item>
            <ion-input
              class="ion-text-right"
              autocapitalize="true"
              formControlName="jerseyNumber"
              placeholder="Enter player number"
              maxlength="3"
              minLength="1"
              (keypress)="validateOnlyNumber($event)"
            >
              <div slot="label">
                Player Number <ion-text color="danger">*</ion-text>
              </div>
            </ion-input>
          </ion-item>
        </ion-list>
    </form>

    <ion-toolbar color="white">
      <ion-button
        color="primary"
        (click)="saveJerseyNumber()"
        expand="block"
        translate
        [disabled]="form?.get('jerseyNumber')?.value?.length < 1"
        class="m-250"
      >
       Save
      </ion-button>
    </ion-toolbar>
</div>